<template>
  <div v-if="isClose" class="closeTxt">{{ gconfig.RegistStopWords }}</div>
  <template v-else>
    <!-- <step :active="0" v-show="(isWeX && openid) || !isWeX"></step> -->
    <div class="loginForm" v-show="(isWeX && openid) || !isWeX">
      <div class="bannerbox">
        <img src="https://pohto-imgs.oss-cn-beijing.aliyuncs.com/uploads/2025/1106/320025FB40AC5888.jpg" alt="" />
      </div>
      <!--<div class="enBox" v-if="gconfig.OverSeaLink" >
        <a :style="{ color: gconfig.mainColor }" :href="gconfig.OverSeaLink"
          ><img :src="enImg" style="width: 28px" alt=""
        /></a>
      </div>-->
      <div
        class="exhName"
        v-if="gconfig.HomePageTitle"
        v-html="gconfig.HomePageTitle"
      ></div>
      <h3 class="exhName" v-else>{{ gconfig.ExhibitionName }}</h3>
      <div class="logins">
        <div class="tabs" v-if="gconfig.Isgat === 'True'">
          <span
            @click="tabChange('dl')"
            :class="tabnow === 'dl' ? 'active' : ''"
            :style="tabnow === 'dl' ? activeBorder : {}"
            >中国大陆注册</span
          >
          <span
            @click="tabChange('gat')"
            :class="tabnow === 'gat' ? 'active' : ''"
            :style="tabnow === 'gat' ? activeBorder : {}"
            >港澳台注册</span
          >
        </div>
        <div class="loginFormbox" v-show="tabnow === 'dl'">
          <van-form ref="loginForm" @submit="onSubmit">
            <div class="formItem">
              <van-field
                v-model="form.mobile"
                name="mobile"
                placeholder="请输入手机号"
                left-icon="shouji"
                color="red"
                :rules="[
                  {
                    required: true,
                    validator: validatorMobile,
                    message: '请输入正确的手机号'
                  }
                ]"
              >
                <template #left-icon>
                  <van-icon
                    class="iconfont"
                    class-prefix="icon"
                    name="shouji"
                    color="#02599f"
                  ></van-icon>
                </template>
              </van-field>
            </div>
            <div class="formItem">
              <van-cell-group>
                <van-field
                  v-model="form.code"
                  center
                  clearable
                  name="code"
                  placeholder="请输入短信验证码"
                  maxlength="4"
                  :rules="[
                    {
                      required: true,
                      validator: validatorCode,
                      message: '请输入正确的短信验证码'
                    }
                  ]"
                >
                  <template #left-icon>
                    <van-icon
                      class="iconfont"
                      class-prefix="icon"
                      name="dunpai"
                      color="#02599f"
                    ></van-icon>
                  </template>
                  <template #button>
                    <van-button
                      class="smsBtn"
                      style="width: 100%"
                      :disabled="btnTxt !== '发送验证码'"
                      plain
                      :color="mainColor"
                      @click="getSms"
                      round
                      size="small"
                      type="primary"
                      >{{ btnTxt }}</van-button
                    >
                  </template>
                </van-field>
              </van-cell-group>
            </div>
            <div
              :class="gconfig.MobilePageBottomText ? 'btnbox' : 'btnbox pad40'"
            >
              <van-button
                type="primary"
                :color="btnColor"
                native-type="submit"
                round
              >
                注册/登录
              </van-button>
            </div>
          </van-form>
        </div>
        <!-- 邮箱 -->
        <div class="loginFormbox" v-show="tabnow === 'gat'">
          <van-form ref="loginFormG" @submit="onSubmitG">
            <!-- <div class="formItem">
              <van-field
                v-model="formG.Name"
                name="Name"
                label="姓名"
                placeholder="请输入正确的姓名"
                :rules="[
                  {
                    required: true,
                    validator: validatorName,
                    message: '请输入正确的姓名'
                  }
                ]"
              />
            </div> -->
            <div class="formItem">
              <van-field
                v-model="formG.Email"
                name="Email"
                left-icon="envelop-o"
                placeholder="请输入正确的邮箱"
                :rules="[
                  {
                    required: true,
                    validator: validatorEmail,
                    message: '请输入正确的邮箱'
                  }
                ]"
              >
                <template #left-icon>
                  <van-icon
                    class="iconfont"
                    class-prefix="icon"
                    name="youjian"
                    color="#02599f"
                  ></van-icon>
                </template>
              </van-field>
            </div>
            <div class="formItem">
              <van-cell-group>
                <van-field
                  v-model="formG.code"
                  center
                  clearable
                  name="code"
                  placeholder="请输入邮箱验证码"
                  left-icon="shield-o"
                  maxlength="4"
                  :rules="[
                    {
                      required: true,
                      validator: validatorCode,
                      message: '请输入正确的邮箱验证码'
                    }
                  ]"
                >
                  <template #left-icon>
                    <van-icon
                      class="iconfont"
                      class-prefix="icon"
                      name="dunpai"
                      color="#02599f"
                    ></van-icon>
                  </template>
                  <template #button>
                    <van-button
                      style="width: 100%"
                      :disabled="btnTxt !== '发送验证码'"
                      plain
                      @click="getEmailSms"
                      round
                      size="small"
                      type="primary"
                      class="smsBtn"
                      >{{ btnTxt }}</van-button
                    >
                  </template>
                </van-field>
              </van-cell-group>
            </div>
            <div
              :class="gconfig.MobilePageBottomText ? 'btnbox' : 'btnbox pad40'"
            >
              <van-button
                type="primary"
                :color="btnColor"
                native-type="submit"
                round
              >
                注册/登录
              </van-button>
            </div>
          </van-form>

        </div>

      </div>
      <div class="adBox" v-html="gconfig.MobilePageBottomText"></div>
    </div>
  </template>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api/index.js'
import { showLoadingToast, showToast } from 'vant'
import { regMobile, regEmail } from '@/utils/regs.js'

import wx from '@/utils/wx.js'
import { decryptionECB } from '@/utils/utils.js'
import enImg from '@/assets/en.png'
const store = useStore()
const router = useRouter()
const route = useRoute()
// 保存入口路径

if (route.query.source) {
  sessionStorage.setItem('source', route.query.source)
}
// 邀请参数
if (route.query.invitesource) {
  sessionStorage.setItem('invitesource', route.query.invitesource)
}
if (route.query.invitesourceID) {
  sessionStorage.setItem('invitesourceID', route.query.invitesourceID)
}
if (route.query.lan) {
  sessionStorage.setItem('lan', route.query.lan)
}
if (route.query.IsGroup) {
  sessionStorage.setItem('IsGroup', route.query.IsGroup)

}
if (route.query.ExhCode) {
  store.commit('setExhCode', route.query.ExhCode)
} else {
  showToast({
    message: '展会参数缺失！',
    wordBreak: 'break-all',
    type: 'fail'
  })
}
const openid = computed(() => store.state.openid)
const isWeX = computed(() => store.state.isWeX)
if (/micromessenger/i.test(navigator.userAgent)) {
  store.commit('setIsWeX', true)
}
const ExhCode = computed(() => {
  return store.state.ExhCode
})
const mainColor = computed(() => store.state.mainColor)
const tabnow = ref('dl')

const showNotOpenToast = () => {
  showToast({
    message: '暂未开放',
    type: 'fail',
    duration: 2000
  })
}
const tabChange = (type) => {
  btnTxt.value = '发送验证码'
  clearInterval(timer.value)
  tabnow.value = type
}
const formG = ref({
  code: '',
  Email: ''
})
// 校验邮箱
const validatorEmail = (val) => {
  return regEmail.test(val)
}

const form = ref({
  code: '',
  mobile: ''
})
// 校验手机号
const validatorMobile = (val) => {
  return regMobile.test(val)
}
// 校验验证码格式
const regCode = /^[0-9]{4}$/
const validatorCode = (val) => {
  return regCode.test(val)
}
const loginForm = ref()
// 登录
const onSubmit = () => {
  loginForm.value.validate().then((valid) => {
    if (!valid) {
      api
        .checkMobileLoginApi({
          mobile: form.value.mobile,
          smscode: form.value.code,
          ExhCode: ExhCode.value,
          OpenID: openid.value
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              // 邮箱已注册
              if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                sessionStorage.setItem('invitesourceID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                  router.push({ path: '/success' })
                }
              }
            } else {
              store.commit('setLoginForm', form.value)
              sessionStorage.setItem('tabac', tabnow.value)
              router.push({ path: '/msg' })
            }
          }
        })
    }
  })
}
onMounted(() => {
  showLoadingToast({
    duration: 0,
    message: '加载中...',
    forbidClick: true
  })
  getToken()
})
const token = computed(() => {
  return store.state.token
})
const getToken = async () => {
  const res = await api.getTokenApi()
  store.commit('setToken', res.data.authorToken)
  getOpenID()
  getGlobalConfig()
}
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const activeBorder = computed(() => {
  return {
    borderColor: store.state.mainColor
  }
})

const getGlobalConfig = async () => {
  const res = await api.getGConfig({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    const tmpObj = {}
    const resObj = JSON.parse(decryptionECB(res.data.configuartion))
    resObj.forEach((item) => {
      tmpObj[item.GlobalKey] = item.GlobalValue
    })

    store.commit('setGConfig', res.data.configuartion)
    store.commit('setMainColor', tmpObj.ButtonColor)
    // 判断展会是否关闭
    closeRes(gconfig.value.RegistStopTime)
    // closeRes('2023-02-04 14:00:00')
    if (isWeX.value) {
      wx.getWXSign()
    }
  }
}
const isClose = ref(false)
const closeRes = (str) => {
  const val = str.replace(/-/g, '/')
  isClose.value = new Date().getTime() >= new Date(val).getTime()
}
const timer = ref(null)
const downTime = (time) => {
  timer.value = setInterval(() => {
    if (time > 0) {
      time--
      btnTxt.value = `${time}s`
    } else {
      btnTxt.value = '发送验证码'
      clearInterval(timer.value)
    }
  }, 1000)
}
const btnTxt = ref('发送验证码')
const getSms = () => {
  loginForm.value.validate('mobile').then((valid) => {
    if (!valid) {
      api
        .getSmsCodeApi({
          mobile: form.value.mobile,
          token: token.value,
          ExhCode: ExhCode.value
        })
        .then((res) => {
          if (res.code === 200) {
            downTime(60)
            showToast({
              message: '短信验证码已发送成功，请注意查收！',
              wordBreak: 'break-all',
              type: 'success'
            })
          }
        })
    }
  })
}
const loginFormG = ref()
const getEmailSms = () => {
  loginFormG.value.validate('Email').then((valid) => {
    if (!valid) {
      api
        .getEmailCodeApi({
          Email: formG.value.Email,
          token: token.value,
          ExhCode: ExhCode.value
        })
        .then((res) => {
          if (res.code === 200) {
            downTime(60)
            showToast({
              message: '验证码已发送成功，请注意查收！',
              wordBreak: 'break-all',
              type: 'success'
            })
          }
        })
    }
  })
}
const getOpenID = () => {
  // 当前链接加获取时间
  const cUrl = window.location.href + '&time=' + Math.round(new Date() / 1000)
  if (isWeX.value) {
    if (cUrl.indexOf('openid') === -1) {
      if (cUrl.indexOf('InviteType') !== -1) {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}&InviteType=eg`
      } else {
        window.location.href = `https://reg.alljoy.com.cn/BackCenter/Wechat/GetopenId?ExhCode=${
          ExhCode.value
        }&url=${encodeURIComponent(cUrl)}`
      }
    } else {
      // 如果有openid
      store.commit('setOpenID', route.query.openid)
      // 根据openid判断是否注册
      if (openid.value) {
        checkOpenid()
      } else {
        router.go(0)
      }
    }
  }
}
const checkOpenid = () => {
  api
    .checkIdentityLoginApi({
      openid: openid.value,
      ExhCode: ExhCode.value,
      aliID: ''
    })
    .then((res) => {
      if (res.code === 200) {
        if (res.data) {
          store.commit('setVisitorID', res.data.visitorID)
          sessionStorage.setItem('invitesourceID', res.data.visitorID)
          if (gconfig.value.SuccessPageVersion === 'V2') {
            router.push({ path: '/successV2' })
          } else {
            router.push({ path: '/success' })
          }
        }
      }
    })
}

//  港澳台登录
const onSubmitG = () => {
  loginFormG.value.validate().then((valid) => {
    if (!valid) {
      showLoadingToast({
        message: 'loading...',
        forbidClick: true
      })
      api
        .CheckEmailnoNameLoginApi({
          Email: formG.value.Email,
          emailcode: formG.value.code,
          ExhCode: ExhCode.value,
          OpenID: openid.value
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              // 邮箱已注册
              if (res.data.visitorID) {
                store.commit('setVisitorID', res.data.visitorID)
                if (gconfig.value.SuccessPageVersion === 'V2') {
                  router.push({ path: '/successV2' })
                } else {
                  router.push({ path: '/success' })
                }
              }
            } else {
              sessionStorage.setItem('tabac', tabnow.value)
              store.commit('setLoginForm', formG.value)
              router.push({ path: '/msg' })
            }
          }
        })
    }
  })
}

const btnColor = ref(
  'linear-gradient( 90deg, #02599F 0%, #55A972 80%,  #A1C98B 100%)'
)
</script>
<style lang="less">
@import '../../assets/login.less';
.closeTxt {
  padding-top: 100px;
}
.loginForm {
 // padding-top: 12vw;
  // background: url('../../assets/vis/bg.png') no-repeat top center;
  background-size: cover;
  .van-field {
    border: 1px solid #666;
    display: flex;
    align-items: center;
    padding: 0 1vw;
    width: 90%;
    margin: 0 auto 3vw;

    .van-field__body {
      border: 0;
      margin: 0;
    }
  }
  .formItem{
    margin-top:20px;
  }
  .bannerbox {
    img {
      width: 100%;
    }
  }
  .enBox {
    text-align: right;
    padding: 0 3vw;
    margin-top: 10px;
  }
  .tabs {
    border-bottom: 1px solid #fff;
    width: 90%;
    margin: 0 auto 6px;
    display: flex;
    span {
      display: inline-block;
      flex: 1;
      text-align: center;
      padding: 10px 0;
    }
    .active {
      background: rgba(255, 255, 255, 0.6);
      border-radius: 4px 4px 0 0;
      // border-bottom: 2px solid #1989fa;
      border-bottom: 1px solid;
      border-image-source: linear-gradient(to right, #02599f, #a1c98b);
      border-image-slice: 1;
    }
  }
  .logins {
    padding: 30px 10px 0;
    width: 85vw;
    border: 1px solid #eee;
    margin: 0 auto;
    border-radius: 36px;
    box-shadow: 0 0 10px #55a972;
    background: #fff;
    .loginTit {
      font-size: 5vw;
      padding-bottom: 2vw;
    }
  }
  .loginFormbox {
   // padding-top: 5vw;
    .smsBtn.van-button--plain.van-button--primary {
      height: 40px;
      border: 0;
      // border-left: 1px solid #666 !important;
      border-radius: 0;
      padding: 0;
      .van-button__content {
        box-shadow: 0px 0px 4px #c1c1c1;
        color: #035a9f;
        height: 6vw;
        padding: 0 3vw;
        border-radius: 3vw;
      }
    }
  }
  .exhName {
    padding: 15px 12px 30px;
    line-height: 15px;
    color: #2c3e50;
  }
  .btnbox {
    padding: 6vw 4vw;
    .van-button {
      width: 100%;
      font-size: 17px
    }
  }
  .pad40 {
    padding-bottom: 40px;
    font-size: 17px
  }
  .adBox {
    padding: 8vw 0 10vw 0;
  }
}
@media screen and (min-width: 768px) {
  .loginForm {
    padding-top: 10px;
    .btnbox{
      padding: 2vw 4vw;
    }
    .loginFormbox {
    padding-top: 2vw;
    }
    .adBox{
      padding: 2vw 0 10vw 0;
    }
    .tabs {
      span {
        cursor: pointer;
      }
    }
    .logins {
      width: 600px;
      .loginTit {
        font-size: 24px;
      }
      .smsBtn.van-button--plain.van-button--primary {
        .van-button__content {
          width: 90px;
          height: 30px;
          line-height: 30px;
          padding: 0;
        }
      }
    }
  }
}
</style>
